export const DOCUMENT_LOADED                   = "document_loaded"
export const DOCUMENT_LOAD_FAILED              = "document_load_failed"
export const DOCUMENT_SAVED                    = "document_saved"
export const DOCUMENT_SAVE_FAILED              = "document_save_failed"
export const DOCUMENT_DURATION                 = "document_duration"
export const CONVERT_FILE_TO_PDF_STARTED       = "convert_file_to_pdf_started"
export const CONVERT_FILE_TO_PDF_SUCCESS       = "convert_file_to_pdf_success"
export const CONVERT_FILE_TO_PDF_FAILED        = "convert_file_to_pdf_failed"
export const CONVERT_PDF_FROM_WEBPAGE_STARTED  = "convert_pdf_from_webpage_started"
export const CONVERT_PDF_FROM_WEBPAGE_SUCCESS  = "convert_pdf_from_webpage_success"
export const CONVERT_PDF_FROM_WEBPAGE_FAILED   = "convert_pdf_from_webpage_failed"
export const COMBINE_FILES_STARTED             = "combine_files_started"
export const COMBINE_FILES_SUCCESS             = "combine_files_success"
export const COMBINE_FILES_FAILED              = "combine_files_failed"
export const EXPORT_ALL_IMGS_STARTED           = "export_all_imgs_started"
export const EXPORT_ALL_IMGS_SUCCESS           = "export_all_imgs_success"
export const EXPORT_ALL_IMGS_FAILED            = "export_all_imgs_failed"
export const CONVERT_TO_WORD_STARTED           = "convert_to_word_started"
export const CONVERT_TO_WORD_SUCCESS           = "convert_to_word_success"
export const CONVERT_TO_WORD_FAILED            = "convert_to_word_failed"
export const CONVERT_TO_EXCEL_STARTED          = "convert_to_excel_started"
export const CONVERT_TO_EXCEL_SUCCESS          = "convert_to_excel_success"
export const CONVERT_TO_EXCEL_FAILED           = "convert_to_excel_failed"
export const CONVERT_TO_POWERPOINT_STARTED     = "convert_to_powerpoint_started"
export const CONVERT_TO_POWERPOINT_SUCCESS     = "convert_to_powerpoint_success"
export const CONVERT_TO_POWERPOINT_FAILED      = "convert_to_powerpoint_failed"
export const CONVERT_TO_IMAGE_STARTED          = "convert_to_image_started"
export const CONVERT_TO_IMAGE_SUCCESS          = "convert_to_image_success"
export const CONVERT_TO_IMAGE_FAILED           = "convert_to_image_failed"
export const CONVERT_TO_RICH_TEXT_STARTED      = "convert_to_rich_text_started"
export const CONVERT_TO_RICH_TEXT_SUCCESS      = "convert_to_rich_success"
export const CONVERT_TO_RICH_TEXT_FAILED       = "convert_to_rich_failed"
export const CONVERT_TO_TEXT_STARTED           = "convert_to_plain_text_started"
export const CONVERT_TO_TEXT_SUCCESS           = "convert_to_plain_success"
export const CONVERT_TO_TEXT_FAILED            = "convert_to_plain_failed"
export const CONVERT_TO_HTML_STARTED           = "convert_to_html_started"
export const CONVERT_TO_HTML_SUCCESS           = "convert_to_html_success"
export const CONVERT_TO_HTML_FAILED            = "convert_to_html_failed"
export const CONVERT_PDF_OPTIMIZER_STARTED     = "pdf_optimizer_started"
export const CONVERT_PDF_OPTIMIZER_SUCCESS     = "pdf_optimizer_success"
export const CONVERT_PDF_OPTIMIZER_FAILED      = "pdf_optimizer_failed"
export const CONVERT_SPLIT_PDF_STARTED         = "split_pdf_started"
export const CONVERT_SPLIT_PDF_SUCCESS         = "split_pdf_success"
export const CONVERT_SPLIT_PDF_FAILED          = "split_pdf_failed"
export const CONVERT_ADD_HEADER_FOOTER_STARTED = "add_header_footer_started"
export const CONVERT_ADD_HEADER_FOOTER_SUCCESS = "add_header_footer_success"
export const CONVERT_ADD_HEADER_FOOTER_FAILED  = "add_header_footer_failed"
//export const SIGN_UP_SUCCESS_FROM_FACEBOOK     = "sign_up_success_from_facebook"
//export const SIGN_UP_SUCCESS_FROM_LINKEDIN     = "sign_up_success_from_linkedin"
//export const SIGN_UP_SUCCESS_FROM_MICROSOFT    = "sign_up_success_from_microsoft"
//export const SIGN_UP_SUCCESS_FROM_GOOGLE       = "sign_up_success_from_google"
export const SIGN_UP_SUCCESS_FROM_XXX       = "sign_up_success_from_xxx"
export const SIGN_UP_SUCCESS_FROM_FOXIT         = "sign_up_success_from_foxit"
export const SIGN_UP_FAILED_FROM_FOXIT          = "sign_up_failed_from_foxit"
export const SIGN_IN_SUCCESS                   = "sign_in_success"
export const SIGN_IN_FAILED                    = "sign_in_failed"

export const EVENTS_CONVERT ={
    CONVERT_FILE_TO_PDF_STARTED,
    CONVERT_FILE_TO_PDF_SUCCESS,
    CONVERT_FILE_TO_PDF_FAILED,
    CONVERT_PDF_FROM_WEBPAGE_STARTED,
    CONVERT_PDF_FROM_WEBPAGE_SUCCESS,
    CONVERT_PDF_FROM_WEBPAGE_FAILED,
    COMBINE_FILES_STARTED,
    COMBINE_FILES_SUCCESS,
    COMBINE_FILES_FAILED,
    EXPORT_ALL_IMGS_STARTED,
    EXPORT_ALL_IMGS_SUCCESS,
    EXPORT_ALL_IMGS_FAILED,
    CONVERT_TO_WORD_STARTED,
    CONVERT_TO_WORD_SUCCESS,
    CONVERT_TO_WORD_FAILED,
    CONVERT_TO_EXCEL_STARTED,
    CONVERT_TO_EXCEL_SUCCESS,
    CONVERT_TO_EXCEL_FAILED,
    CONVERT_TO_POWERPOINT_STARTED,
    CONVERT_TO_POWERPOINT_SUCCESS,
    CONVERT_TO_POWERPOINT_FAILED,
    CONVERT_TO_IMAGE_STARTED,
    CONVERT_TO_IMAGE_SUCCESS,
    CONVERT_TO_IMAGE_FAILED,
    CONVERT_TO_RICH_TEXT_STARTED,
    CONVERT_TO_RICH_TEXT_SUCCESS,
    CONVERT_TO_RICH_TEXT_FAILED,
    CONVERT_TO_TEXT_STARTED,
    CONVERT_TO_TEXT_SUCCESS,
    CONVERT_TO_TEXT_FAILED,
    CONVERT_TO_HTML_STARTED,
    CONVERT_TO_HTML_SUCCESS,
    CONVERT_TO_HTML_FAILED,
    
    CONVERT_PDF_OPTIMIZER_STARTED,
    CONVERT_PDF_OPTIMIZER_SUCCESS,
    CONVERT_PDF_OPTIMIZER_FAILED,
    CONVERT_SPLIT_PDF_STARTED,
    CONVERT_SPLIT_PDF_SUCCESS,
    CONVERT_SPLIT_PDF_FAILED,
    CONVERT_ADD_HEADER_FOOTER_STARTED,
    CONVERT_ADD_HEADER_FOOTER_SUCCESS,
    CONVERT_ADD_HEADER_FOOTER_FAILED,
}